// extracted by mini-css-extract-plugin
export default {"table":"styles_table__aFUWq","selected-row":"styles_selected-row__A4yCt","checkbox":"styles_checkbox__m8lWN"};